export default __webpack_public_path__ + "static/media/Gloves of the Firebrand.f254ac35.jpg";